module.exports = __webpack_public_path__ + "img/ceiling_fan_installation.f97c94a6.jpg";